import React, { useState } from "react";
import useFetchJSONData from "@hooks/useFetchJSONData";
import { Swiper, SwiperSlide } from "swiper/react";

import "./SlidingAnnouncements.scss";

// swiper bundle styles
import "swiper/swiper-bundle.min.css";

// swiper core styles
import "swiper/swiper.min.css";

function Announcement({ text, url, isOpenInNewWindow }) {
  const lang = window.THREE_REACT_APP_GLOBAL.language;
  const tag = lang == "en" ? "Important Notice:" : "重要啟示:";
  const target = isOpenInNewWindow ? "_blank" : "_self";
  if (url) {
    return (
      <div className="content-container">
        <a target={target} href={url} className="content-wrapper">
          <span className="tag">{tag}</span>
          <span className="message">{text}</span>
        </a>
      </div>
    );
  }

  return (
    <div className="content-container">
      <div className="content-wrapper">
        <span className="tag">{tag}</span>
        <span className="message">{text}</span>
      </div>
    </div>
  );
}

export default function SlidingAnnouncements() {
  const [isVisible, setIsVisible] = useState(true);
  const { data, loading, error } = useFetchJSONData("sliding-announcements");

  function handleDismiss() {
    setIsVisible(false);
  }

  if (!isVisible) return null;

  if (loading || error || !data || !data.slidingAnnouncements) return null;

  const { slidingAnnouncements } = data;

  if (slidingAnnouncements === null || slidingAnnouncements.length === 0)
    return null;

  return (
    <div className="container-auto-scroll-alert-message-box">
      <div className="wrapper">
        <Swiper
          direction={"vertical"}
          spaceBetween={0}
          observer={true}
          loop={slidingAnnouncements.length > 1}
          allowTouchMove={false}
          watchOverflow={true}
          speed={1500}
          className="auto-scroll-alert-message-swiper"
          autoplay={
            1 > 0
              ? {
                  delay: 5000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: false,
                  stopOnLastSlide: false,
                  waitForTransition: true,
                }
              : false
          }
        >
          {slidingAnnouncements.map(({ text, url, isOpenInNewWindow }, i) => (
            <SwiperSlide key={i}>
              <Announcement {...{ text, url, isOpenInNewWindow }} />
            </SwiperSlide>
          ))}
        </Swiper>
        <button onClick={handleDismiss} className="btn-dismiss" />
      </div>
    </div>
  );
}
